export const formatDate = (date: Date) => {
  if (!date) return '';

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
  };

  return `${date.toLocaleDateString('nl-NL', options)}`;
};
